// extracted by mini-css-extract-plugin
export default {"content":"uiWZyVty","desktop":"desktop","commentsButton":"FYhSgS_T","mobile":"mobile","list":"Vi6sastL","item":"y0jrhvqk"};